export default {
  getImageDimensions: (fileUrl, cb) => {
    cb && cb({ width: 0, height: 0 })
  },
}
